import React, { useState, useEffect } from 'react';
import { Button, Container, Form, } from 'react-bootstrap';
import FormLabel from '../../common/FormLabel';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import LoadButton from '../../common/LoadButton';
import { ADD_CAPTAIN, MY_SCHOOL_ROUTE, PARTNER_ADD_TREEHOUSE } from '../../../constants/routes.constants';
import PartnerHeader from './PartnerHeader';
import { schoolViewModel } from './school.view.model';
import { useAuth } from '../../auth/Auth';
import { settingsViewModel } from '../dashboard/settings.view.model';

const CampReassignKid = () => {
  const history = useHistory();
  const dependent_id = history?.location?.state?.dependent_id;
  const dependent_username = history?.location?.state?.dependent_username;
  const group_id = history?.location?.state?.group_id;
  const { school } = useAuth();
  const [treehouseDetails, setTreehouseDetails] = useState();
  const [treehousesList, setTreehousesList] = useState([]);
  const [tribeList, setTribeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });
  const pageRedirect = () => {
    history.goBack();
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };


  const getTribesList = () => {
    if (school) {
      const params = {
        limit: 99
      }
      let API = school?.user_type === "school" ? schoolViewModel?.getCampMasterTribes : schoolViewModel?.getCampCaptainTribes
      API(school?.id, params).then((res) => {
        setTribeList(res);
        setTreehousesList(res?.map((obj) => {
          return { value: obj?.id, label: obj?.name }
        }));
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  useEffect(() => {
    getTribesList()
  }, [])

  const onSubmit = handleSubmit((formData) => {
    setIsLoading(true);
    let params = {
      dependent_id: dependent_id,
      group_code: treehouseDetails?.group_code
    }
    settingsViewModel.connectTreehouse(params).then((res) => {
      //   console.log(res)
      setIsLoading(false);
      pageRedirect();
    }).catch((err) => {
      console.log(err)
      setIsLoading(false)
    })
  })

  const handleTribeChange = (e) => {
    let tribe = tribeList.find(obj => obj?.id === e.value)
    setTreehouseDetails(tribe)
  }

  return (
    <div className='partner-wrapper-main'>
      <PartnerHeader />
      <div className='add-more-branches partner_add_challenges'>
        <span className="back-btn" onClick={pageRedirect}><HiOutlineChevronLeft /></span>
        <Container>
          <div>
            <div className="d-flex justify-content-center">
              <div className='a-challenge-partner'>
                <h2 className='mb-60'>Reassign {dependent_username}</h2>
                {group_id &&
                  <Form>
                    <Form.Group className="mb-3" controlId="">
                      <FormLabel>Select a new tribe</FormLabel>
                      <Select
                        options={treehousesList}
                        // defaultValue={treehousesList[treehousesList.findIndex(item => item.value === Number(group_id))]}
                        styles={customStyles}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: '6px',
                          colors: {
                            ...theme.colors,
                            primary: '#80e4e1',
                          },
                        })}
                        onChange={handleTribeChange}
                      />
                    </Form.Group>
                  </Form>
                }
                {treehouseDetails?.id &&
                  <LoadButton
                    className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                    text="Save Changes"
                    isLoading={isLoading}
                    testid="submit"
                    onClick={onSubmit}
                  />
                }
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}
export default CampReassignKid;